import { useEffect, useState } from "react";
import Header from "./Header";
import Sidebar from "./SideBar";
import { useSidebar } from "../SidebarContext";
import AddCategoryModal from "./AddCategoryModal";
import { toast } from "react-toastify";
import EditCategoryModal from "./EditCategoryModal";
import { useNavigate } from "react-router-dom";



function Feedback() {
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    const [customers, setCustomers] = useState([]);

    const { isSidebarOpen } = useSidebar();
    const [filteredCustomers, setFilteredCustomers] = useState(customers);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalOpen1, setIsModalOpen1] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    // Effect to handle filtering
    useEffect(() => {
        const filtered = customers.filter((customer) =>
            Object.values(customer).some((value) =>
                String(value).toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredCustomers(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [searchQuery, customers]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
    const currentData = filteredCustomers.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Handle Delete



    const [showAlert, setShowAlert] = useState(false);






    const [show6, setShow6] = useState(false);
    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);
    const [show7, setShow7] = useState(false);
    const handleClose7 = () => setShow7(false);
    const handleShow7 = () => setShow7(true);

    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [data, setData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        category: '',
        status: '',
        position: '',
        user_id: isLoggedIn.user_id
    });

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };


    const fetchData = async () => {
        try {
            const response = await fetch(`https://100real.xyz/feedback/all/${isLoggedIn.user_id}`);
            const res = await response.json();
            setCustomers(res.reverse());
            console.log(res);
        } catch (error) {
            console.log(error);
        }
    };


    const handleDelete = async (id) => {
        try {
            let response = await fetch(`https://100real.xyz/feedback/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json"
                }
            })
            let res = await response.json();
            setCustomers(currentData.filter((movie) => movie.id !== id));
            toast.success("Feedback deleted successfully!", {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
        } catch (error) {
            toast.error(error, {
                position: "top-center",
                autoClose: 2000, // Close toast after 3 seconds
            });
        }
    }

    useEffect(() => {
        fetchData();
    }, []);
    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Feedback</h1>

                    {/* Add Offers Button */}
                    {/* <button className="oms-add-btn" onClick={() => setIsModalOpen(true)}>
                        Add Category
                    </button> */}
                </div>

                {/* Search Filter */}
                <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i> {/* Font Awesome Search Icon */}
                    </div>
                </div>

                {/* Customer Table */}
                <div className="customer-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Description</th>
                                <th>Created At</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((customer, index) => (
                                    <tr key={index}>
                                        <td style={{ cursor: "pointer" }} >{customer.name}</td>
                                        {/* <td>
                                            <a href={`/${customer.receipt}`} target="_blank" rel="noopener noreferrer">
                                                View
                                            </a>
                                        </td> */}
                                        <td>{customer.email}</td>
                                        <td>{customer.description}</td>
                                        <td>{new Date(customer.createdAt).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</td>
                                        <td>
                                            <button
                                                onClick={() => handleDelete(customer.id)}
                                            >
                                                <i className="fa fa-trash" />
                                            </button>
                                        </td>

                                        {/* <td>
                                            <button className="edit-button" onClick={() => {

                                                setEditId(customer.id);
                                                setFormData({
                                                    category: customer.category,
                                                    status: customer.status,
                                                    position: customer.position,
                                                    user_id: isLoggedIn.user_id
                                                })
                                                setIsModalOpen1(true)
                                            }}>
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>
                                            <button
                                                className="delete-button"
                                                onClick={() => handleDetete(customer.id)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td> */}
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>No data found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination">
                    <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
                        <i class="fa-solid fa-chevron-left"></i><i class="fa-solid fa-chevron-left"></i>
                    </button>



                    <button className="active">
                        {currentPage}
                    </button>

                    {currentPage < totalPages && (
                        <button onClick={() => paginate(currentPage + 1)}>
                            {currentPage + 1}
                        </button>
                    )}

                    {currentPage + 1 < totalPages && (
                        <span className="dots">...</span>
                    )}

                    {currentPage !== totalPages && (
                        <button onClick={() => paginate(totalPages)}>
                            {totalPages}
                        </button>
                    )}

                    <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>
                        <i class="fa-solid fa-chevron-right"></i><i class="fa-solid fa-chevron-right"></i>
                    </button>
                </div>
            </div>


        </>
    )
}

export default Feedback;

